// CANONICAL COPY (GH #7115). src/constants/obligations/obl-legal-register.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-legal-register',
  title: 'Maintain register of legal, regulatory and contractual requirements',
  description:
    'Review and update the register of applicable legal, statutory, regulatory, and contractual requirements.',
  category: 'compliance',
  scfIds: ['SCF-GOV-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Legal requirements register is published' },
    { type: 'document-within-sla', description: 'Register review is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
